import * as React from "react"
import { Skeleton } from "@mui/material"

import { usePricingDiscountTopMarketDispersionsRoleConfig } from "./@hooks"
import PriceTopMarketDispersionTabs from "./Tabs"
import PriceDiscountTopMarketDispersionsTable from "./Table"
import {DISPLAY_TABS} from "./@constants";


export default function PriceDiscountTopMarketDispersions() {

    const {
        isLoading, currentData, loadedData, countries, selectedCountry, displayTab, handleChangeTabs,
        handleSelectedCountry
    } = usePricingDiscountTopMarketDispersionsRoleConfig()

    if (isLoading) return <Skeleton variant="rectangular" height={500} />
    if (!currentData.length && !loadedData) return <></>

    const noDataText = displayTab === DISPLAY_TABS.TOP_HIGHER
        ? 'Ouch! Looks like you’re not the cheapest for any product…'
        : 'Awesome! No one has better deals than you!'

    return <>
        <PriceTopMarketDispersionTabs
            value={displayTab}
            onChange={handleChangeTabs}
        />
        <PriceDiscountTopMarketDispersionsTable
            data={currentData}
            countries={countries}
            selectedCountry={selectedCountry}
            noDataText={noDataText}
            handleSelectedCountry={handleSelectedCountry}
        />
        
    </>
}